var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-input',{ref:"cardReaderInput",staticStyle:{"width":"0","height":"0","opacity":"0"},on:{"change":_vm.change,"focus":_vm.focus,"blur":_vm.blur},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})}
var staticRenderFns = []

export { render, staticRenderFns }